import React from 'react';
import { Typography } from '@mui/material';

const AssignmentActionDetails = ({ assignmentActions, currentVehicleType = null }) => {
  if (!assignmentActions || assignmentActions.length === 0) {
    return null;
  }

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Kolkata',
    });
  };

  return (
    <div className="w-[95%] p-5 bg-white">
      <Typography variant="head5" className="fw600 colorBlack mb-4">
        Assignment History
      </Typography>

      <div className="space-y-4 mt-2">
        {assignmentActions.map((action, index) => (
          <div
            key={index}
            className="bg-gray-50 rounded-lg p-4 border border-gray-100 hover:shadow-md transition-shadow duration-200"
          >
            {/* Header with timestamp and upgrade indicator */}
            <div className="flex items-center justify-between mb-3">
              <Typography variant="body2" className="colorGrey">
                {formatTimestamp(action.timestamp)}
              </Typography>
              {action.isUpgrade && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gradient-to-r from-green-500 to-green-600 text-white">
                  UPGRADE
                </span>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Assignment Reason */}
              <div className="space-y-1">
                <Typography variant="body2" className="colorGrey">
                  Assignment Reason
                </Typography>
                <Typography variant="body2" className="colorBlack" title={action.reason?.category}>
                  {action.reason?.category || 'N/A'}
                </Typography>
                {action.reason?.comments && (
                  <Typography
                    variant="body2"
                    className="colorGrey pl20"
                    title={action.reason.comments}
                  >
                    Comments: {action.reason.comments}
                  </Typography>
                )}
              </div>

              {/* Assigned By */}
              <div className="space-y-1">
                <Typography variant="body2" className="colorGrey">
                  Assigned By
                </Typography>
                <Typography variant="body2" className="colorBlack">
                  {action.assignedByName || 'System'}
                </Typography>
              </div>
            </div>

            {/* Vehicle Upgrade Information */}
            {action.isUpgrade && action.previousVehicle && (
              <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-3">
                <Typography variant="body2" className="colorGrey mb20">
                  Vehicle Upgrade Details
                </Typography>
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <Typography variant="body2" className="colorGrey">
                      From:
                    </Typography>
                    <Typography variant="body2" className="colorBlack fw600">
                      {action.previousVehicle.type || 'Not specified'}
                    </Typography>
                  </div>
                  <div className="text-blue-600 font-bold text-lg">→</div>
                  <div className="flex items-center space-x-2">
                    <Typography variant="body2" className="colorGrey">
                      To:
                    </Typography>
                    <Typography variant="body2" className="colorPrimary fw600">
                      {currentVehicleType || 'Current Vehicle'}
                    </Typography>
                  </div>
                </div>
              </div>
            )}

            {/* Previous Driver Info */}
            {action.previousDriver && (
              <div className="mt-3 pt-3 border-t border-gray-200">
                <Typography variant="body2" className="colorGrey">
                  <span className="fw600">Previous Driver:</span> {action.previousDriverName}
                </Typography>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssignmentActionDetails;
